import api from './api';

class AuthService {
    async login(email, password) {
        const response = await api.post('users/auth/login/', { username: email, password });
        if (response.data.access) {
            localStorage.setItem('access_token', response.data.access);
            localStorage.setItem('refresh_token', response.data.refresh);
            return response.data;
        }
        return response.data;
    }

    async register(data) {
        return api.post('users/', data);
    }

    async checkUser(phone, email) {
        return api.post('users/check_user/', { phone, email });
    }

    async sendOtp(phone, email, firstName) {
        return api.post('users/send_otp/', { phone, email, first_name: firstName });
    }

    async verifyOtp(phone, email, otp) {
        return api.post('users/verify_otp/', { phone, email, otp });
    }

    async getCurrentUser() {
        return api.get('users/me/');
    }

    logout() {
        localStorage.removeItem('access_token');
        localStorage.removeItem('refresh_token');
        localStorage.removeItem('user');
    }
}

export default new AuthService();
